import type { CommentMention } from '../../containers/CommentList/CommentList.types';
import { MENTION_REGEX } from './parsingConstants';

export interface MentionMatch {
  username: string;
  email: string;
  name: string;
  startIndex: number;
  endIndex: number;
  mentionText: string;
}

export const findMentionPositions = (
  text: string,
  commentMentions: CommentMention[]
): MentionMatch[] => {
  const extractedMentions: MentionMatch[] = [];
  commentMentions.forEach(mention => {
    const username = mention.uid.startsWith('@')
      ? mention.uid.slice(1)
      : mention.uid;
    const mentionText = `@${username}`;
    let startIndex = text.indexOf(mentionText);
    while (startIndex !== -1) {
      extractedMentions.push({
        username,
        email: mention.email,
        name: mention.fullName,
        startIndex,
        endIndex: startIndex + mentionText.length,
        mentionText
      });
      startIndex = text.indexOf(mentionText, startIndex + 1);
    }
  });
  return extractedMentions.sort((a, b) => a.startIndex - b.startIndex);
};

export const discoverMentions = (
  text: string
): Array<{
  username: string;
  startIndex: number;
  endIndex: number;
  mentionText: string;
}> => {
  const mentions: Array<{
    username: string;
    startIndex: number;
    endIndex: number;
    mentionText: string;
  }> = [];
  MENTION_REGEX.lastIndex = 0;
  let match;
  while ((match = MENTION_REGEX.exec(text)) !== null) {
    mentions.push({
      username: match[1],
      startIndex: match.index,
      endIndex: match.index + match[0].length,
      mentionText: match[0]
    });
  }
  return mentions;
};
